import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetStudentInterestsQuery } from '../../../../../../redux/services/fj_interests.jsx';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import FjMyInterestsTable from './FjMyInterestsTable.jsx';
import { useNavigate } from 'react-router-dom';

const FjMyInterestsPage = () => {
  const { t } = useTranslation();
  const { data, isLoading, refetch } = useGetStudentInterestsQuery();
  const navigate = useNavigate();

  const pageTitle = t('Môj záujem');

  useEffect(() => {
    document.title = pageTitle + ' - FRI.jobs';
  }, [pageTitle]); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Späť')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <FjMyInterestsTable
            studentsInterest={data}
            refetch={refetch}
            onDetailClick={(record) =>
              navigate(`${routes.cmsFriJobsJobDetail}/${record.fj_job_id}`)
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default FjMyInterestsPage;
